window.initKnowledgeHubSortable = () => {
    const initSortable = (selector, resourceName) => {
        const el = document.querySelector(selector);
        if (!el) return;

        // Destroy existing instance if any
        const existing = Sortable.get(el);
        if (existing) existing.destroy();

        Sortable.create(el, {
            animation: 150,
            handle: '.drag-handle',
            ghostClass: 'sortable-ghost',
            onEnd: function (evt) {
                const itemEl = evt.item;
                const newPosition = evt.newIndex + 1;
                const reorderUrl = itemEl.getAttribute('data-reorder-url');

                if (reorderUrl) {
                    $.ajax({
                        url: reorderUrl,
                        method: 'PATCH',
                        data: { position: newPosition },
                        beforeSend: function(xhr) {
                            xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
                        },
                        success: function(response) {
                            console.log(`${resourceName} reordered successfully`);
                        },
                        error: function(xhr) {
                            alert('Failed to reorder: ' + (xhr.responseJSON?.error || 'Unknown error'));
                            window.location.reload();
                        }
                    });
                }
            }
        });
    };

    initSortable('.sortable-tutorials', 'Tutorial');
    initSortable('.sortable-pdf-guides', 'PDF Guide');
};

document.addEventListener('turbolinks:load', () => {
    window.initKnowledgeHubSortable();
});
